import { render, staticRenderFns } from "./BreztriTabs.vue?vue&type=template&id=d137581a"
import script from "./BreztriTabs.vue?vue&type=script&lang=js"
export * from "./BreztriTabs.vue?vue&type=script&lang=js"
import style0 from "./BreztriTabs.vue?vue&type=style&index=0&id=d137581a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports